module.exports = __webpack_public_path__ + "static/media/Mantenimiento.e198c212.svg";